import { render, staticRenderFns } from "./TransferToNhanh.vue?vue&type=template&id=79080d6c&scoped=true&"
import script from "./TransferToNhanh.vue?vue&type=script&lang=js&"
export * from "./TransferToNhanh.vue?vue&type=script&lang=js&"
import style0 from "./TransferToNhanh.vue?vue&type=style&index=0&id=79080d6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79080d6c",
  null
  
)

export default component.exports